{
  "common": {
    "close_banner": "Close Banner",
    "ok": "OK",
    "load_more": "Load More",
    "close_modal": "Close Modal",
    "rows_per_page": "Rows per page",
    "updated": "Updated",
    "alert_view": "Alert View",
    "close_alert_button": "close alert button",
    "clear_search": "Clear Search"
  },
  "copy_to_clipboard": {
    "copied_message": "Copied: {{content}}",
    "copy_button": "Copy"
  },
  "entity_chips": {
    "show_less": "show less",
    "show_more": "+{{count}} more"
  },
  "success": {
    "default_title": "Success!"
  },
  "badge": {
    "default_aria_label": "{{count}} items"
  },
  "error_boundary": {
    "try_refresh_page": "Try refresh the page"
  },
  "access_role_page": {
    "user_management": "User Management"
  },
  "comment_actions": {
    "aria_label": "comment actions"
  },
  "comment_preview": {
    "edited": "Edited",
    "deleted_message": "This comment has been deleted."
  },
  "remove_comment": {
    "confirm_delete_title": "Are you sure you want to delete this comment?",
    "confirm_delete_content": "Click confirm to delete this comment"
  },
  "dashboard": {
    "weekly_activity_report": "Your Weekly Activity Report",
    "welcome_back": "Welcome back",
    "quick_actions": {
      "my_contacts": "My Contacts",
      "my_companies": "My Companies",
      "opportunities": "Opportunities",
      "tasks": "Tasks",
      "prospects": "Prospects",
      "workspaces": "Workspaces"
    }
  },
  "pages": {
    "not_found_title": "The page you were looking for doesn't exist.",
    "return": "Return",
    "no_permission": "You don't have permission to view this page.",
    "back_to_dashboard": "Back to dashboard"
  },
  "create_tab_menu": {
    "create_new_tab": "create new tab",
    "new_view": "New {{label}}",
    "view": "View",
    "create_view": "Create View",
    "new_contact_list": "New Contact List",
    "new_company_list": "New Company List",
    "create_list": "Create List",
    "new_generic_list": "New Generic List",
    "new_embed_url": "New Embed URL",
    "new_pages": "New Pages",
    "create_pages": "Create Pages",
    "new_campaign": "New Campaign",
    "new_activity_list": "New Activity List"
  },
  "filter_has_changed": {
    "message": "The filter has been changed, would you like to update this tab?",
    "update_tab": "Update tab"
  },
  "update_name_form": {
    "validation_required": "please enter a name",
    "update_list_name": "Update list name",
    "name": "Name"
  },
  "menu_handler": {
    "actions": "Actions"
  },
  "avatar_card": {
    "avatar_label": "{{name}} avatar"
  },
  "filters": {
    "select_property_instruction": "Select a property to filter by",
    "company_in_hierarchy": "Company in Hierarchy",
    "search_main_company_placeholder": "Type to search main company",
    "total_rows": "Total Rows",
    "form": {
      "title": "Filter",
      "select_filter_title": "Select Filter",
      "add_filter": "Add Filter",
      "clear_all": "Clear All",
      "date_operator_label": "date operator",
      "select_value_placeholder": "Select value",
      "type_value_placeholder": "Type Value"
    },
    "sections": {
      "contact_information": "Contact Information",
      "list_information": "List Information",
      "company_information": "Company Information"
    },
    "aria_labels": {
      "remove_filter": "remove filter",
      "filter_item": "filter item",
      "back_button": "back button",
      "show_filters": "show filters",
      "filters_active": "{{count}} filters are active"
    },
    "validation": {
      "operator_required": "Please select an operator",
      "value_required": "Please type a value",
      "values_required": "Please enter a value",
      "both_values_required": "Please enter both values",
      "at_least_one_value_required": "At least one value is required"
    },
    "search_columns": "Search filterable columns",
    "no_matching_found": "No matching filters found",
    "join_operator": "Join Operator",
    "add_filter_aria": "add {{name}} filter",
    "remove_filter_aria": "remove {{label}} filter",
    "filter_already_added_aria": "{{name}} already added",
    "condition_details_aria": "{{label}} filter condition details",
    "press_enter_to_add": "Press Enter to add",
    "type_and_press_enter": "Type and press Enter",
    "enter_value": "Enter value",
    "enter_value_for_aria": "{{placeholder}} for {{label}}",
    "from": "From",
    "to": "To",
    "already_added": "Already added",
    "no_due_date": "No due date",
    "add_filter": "add filter"
  },
  "key_activity": {
    "firm_wide": {
      "title": "Firm Wide",
      "tooltip": "Total key activities across the firm this month",
      "this_month": "This Month"
    },
    "filters": {
      "basic": "Basic",
      "large": "Large",
      "all_employees": "All",
      "select_employee": "Select Employee",
      "select_activity_category": "select activity category",
      "select_month_year": "select month and year"
    },
    "actions": {
      "log_new_activity": "Log new activity",
      "update_aria_label": "update key activity",
      "update_title": "update key activity",
      "remove_aria_label": "remove key activity",
      "remove_title": "remove key activity"
    },
    "grid": {
      "loading_aria_label": "loading key activities",
      "load_limit_message": "There are more key activities than shown.",
      "show_less": "show less",
      "show_more": "+{{count}} more"
    },
    "chart": {
      "business_development": "Business Development Activity",
      "lead_activity": "Lead Activity",
      "marketing_activity": "Marketing Activity"
    },
    "performance": {
      "current": "Current",
      "current_tooltip": "You have logged {{count}} key activities this month",
      "best": "Best",
      "best_tooltip": "Your personal best: {{count}} key activities in a month",
      "consecutive": "Consecutive",
      "weeks": "Weeks",
      "consecutive_tooltip": "You've logged weekly key activities for the past {{count}} weeks",
      "longest": "Longest",
      "longest_tooltip": "Your longest streak: {{count}} weeks"
    }
  },
  "meetings": {
    "calendar_view": {
      "all": "All",
      "tasks": "Tasks",
      "external_meetings": "External Meetings",
      "key_activities": "Key Activities",
      "select_all": "Select All",
      "task_tooltip": "task"
    },
    "contact_table": {
      "show_less": "Show less",
      "show_more": "Show more"
    },
    "key_activity": {
      "activity": "Activity",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Edit activity",
      "remove": "Remove",
      "view_activity_details": "view activity details"
    },
    "recent": {
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "create_task": "Create Task",
      "create_note": "Create Note",
      "no_recent_meetings": "You haven't had a meeting for a while"
    },
    "slide": {
      "aria_label": "meeting slide",
      "add_key_activity": "Add key activity",
      "contacts_involved": "Contacts Involved",
      "staff_involved": "Staff Involved",
      "companies": "Companies"
    },
    "upcoming": {
      "cancelled": "[Cancelled]",
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "no_meetings_coming_up": "There's no meetings coming up"
    }
  },
  "mobile_contact_request": {
    "contact_request_page": {
      "thank_you_message": "Thank you for adding your contacts. You can close this window now.",
      "im_done": "I'm Done"
    },
    "header": {
      "instruction_text": "Please select and add your contacts you want to add to list \"{{listName}}\". Once you have added your contacts, click on \"I'm done\"."
    },
    "my_contacts": {
      "my_contacts": "My Contacts",
      "company_type": "Company type",
      "consent_status": "Consent status",
      "no_contacts_message": "There's no contact to show here"
    },
    "bulk_add": {
      "contact_list": "Contact List",
      "bulk_add_description": "Bulk add contacts to list",
      "adding_in_progress_message": "The contact is being added. Please refresh the page to see the updated list.",
      "adding_in_progress_title": "Adding Contact in Progress",
      "add_selected": "Add Selected"
    },
    "contacts_table": {
      "selected": "selected",
      "contact": "Contact",
      "company": "Company",
      "location": "Location",
      "last_interaction": "Last Interaction"
    },
    "objective_progress": {
      "thanks_for_update": "Thanks for the update :)"
    }
  },
  "my_lists": {
    "page": {
      "search_placeholder": "Search list name",
      "lists_header": "Lists",
      "create_list": "Create List"
    },
    "actions": {
      "add_to_list": "Add to List",
      "list_actions": "List actions",
      "rename_list": "Rename List",
      "share_list": "Share List"
    },
    "navigation": {
      "other_lists": "Other Lists"
    },
    "empty_states": {
      "no_shared_list": "No shared list",
      "your_list_is_empty": "Your List is Empty",
      "no_lists_found": "No Lists Found",
      "no_search_results": "We couldn't find any list matching your search. Try using different keywords or create a new list"
    },
    "confirmations": {
      "archive_list_content": "Are you sure you want to archive this list? It will be removed from the listing.",
      "archive_list_title": "Archive List?",
      "remove_user_title": "Are you sure you want to remove this user?",
      "remove_user_content": "Click confirm to remove"
    },
    "forms": {
      "list_name_required": "Please enter a list name",
      "list_name": "List Name",
      "invitee_required": "Please choose at least one invitee",
      "invite": "Invite",
      "enable_duplicate_contacts": "Enable duplicate contacts",
      "duplicate_contacts_tooltip": "Enabling duplicate contacts allows for multiple entries in forms. However, please note that importing and exporting data may not function properly."
    },
    "share": {
      "invite_tab": "Invite",
      "access_tab": "Access",
      "success_message": "Your list has been successfully shared. We will notify the recipients.",
      "owner": "Owner",
      "loading_users": "Loading users"
    }
  },
  "user_menu": {
    "logged_in_as": "You are logged in as",
    "switch_account": "Switch Account",
    "updated_contacts": "Updated Contacts",
    "help": "Help",
    "individual_connect": "Individual Connect",
    "admin_connect": "Admin Connect ({{consentName}})"
  },
  "duplicate_goal": {
    "header": "Duplicate Opportunity",
    "aria_label": "duplicate opportunity",
    "title": "Duplicate Opportunity"
  },
  "add_document_ui": {
    "add_document_aria_label": "add document",
    "add_document_header": "Add Document",
    "or_separator": "- or -"
  },
  "add_urls": {
    "document_urls_label": "Document URLs (multiple)"
  },
  "archive_opportunity": {
    "confirm_content": "This action cannot be undone",
    "confirm_title": "Are you sure you want to archive this opportunity?",
    "archive_title": "Archive Opportunity"
  },
  "opportunity_grid": {
    "filters": {
      "assign_to": "Assign to",
      "referral_source": "Referral Source",
      "date": "Date"
    },
    "actions_menu": {
      "opportunity_actions": "Opportunity actions",
      "actions": "Actions"
    }
  },
  "basic_opportunities_page": {
    "advanced_button": "Advanced",
    "create_opportunity_button": "Create Opportunity",
    "all_opportunities_tab": "All Opportunities"
  },
  "opportunity_preview": {
    "create_note": "Create Note",
    "share_opportunity": "Share Opportunity",
    "update_opportunity": "Update Opportunity",
    "duplicate_opportunity": "Duplicate Opportunity",
    "archive_opportunity": "Archive Opportunity",
    "opportunity_number": "Opportunity #{{trackingNumber}}",
    "link": "Link",
    "opportunity_for": "Opportunity for",
    "industries": "Industries",
    "status": "Status",
    "internal_owner": "Internal Owner",
    "key_contacts": "Key Contacts",
    "title_description": "Title / Description",
    "tags": "Tags",
    "proposed_fee": "Proposed Fee",
    "team_involved": "Team Involved",
    "referral_source": "Referral Source",
    "proposal_documents": "Proposal Documents",
    "linked_workspaces": "Linked Workspaces",
    "view_original_email": "View original email",
    "details": "Details",
    "history": "History",
    "notes": "Notes"
  },
  "contacts": {
    "all_contacts": "All Contacts",
    "all_employees": "All Employees",
    "results": "Results",
    "company_type": "Company type",
    "consent_status": "Consent status"
  },
  "received_referrals": {
    "loading": {
      "loading_referrals": "Loading referrals",
      "error_prefix": "Error: ",
      "load_limit_message": "Referral table limited to 10,000 rows. Reach out for additional data."
    },
    "create": {
      "track_referral": "TrackReferral"
    },
    "form": {
      "validation": {
        "company_required": "Please enter a company"
      },
      "labels": {
        "referral": "Referral",
        "opportunity": "Opportunity",
        "client_company": "Client Company (Associated Company) *",
        "company_search_placeholder": "Type to search company",
        "client_contact": "Client Contact (Key Contact)",
        "description": "Description",
        "description_placeholder": "Describe your opportunity in one sentence",
        "opportunity_date": "Opportunity Date",
        "date_placeholder": "date",
        "received_by": "Received By (Internal Owner)",
        "received_by_placeholder": "Who will be responsible for this opportunity?",
        "sent_by": "Sent By (Referral Source)",
        "sent_by_placeholder": "Who referred this opportunity?",
        "more_fields": "MORE FIELDS",
        "status": "Status",
        "tags": "Tags",
        "proposed_fee": "Proposed Fee",
        "team_involved": "Team Involved",
        "team_involved_placeholder": "Team involved in this opportunity?"
      }
    },
    "grid": {
      "track_referral_header": "Track a Referral",
      "track_received_referral_aria": "track received referral",
      "track_received_referral": "Track Received Referral",
      "export_filename": "received referrals",
      "open_slider_aria": "open slider"
    }
  },
  "reminder": {
    "create_reminder": "Create Reminder",
    "reminder": "Reminder",
    "dismiss": "Dismiss",
    "dismiss_confirm_title": "Are you sure you want to dismiss the reminder?",
    "dismiss_confirm_content": "Click confirm to dismiss reminder.",
    "no_reminder_for_list": "No reminder for current list",
    "send_to": "Send To",
    "actions": "Actions",
    "select_date_field": "Select date field",
    "validation_subject_required": "Please add a subject",
    "validation_days_required": "Please add reminder days",
    "validation_date_property_required": "Please select a date property",
    "validation_employees_required": "Please select at least 1 employee",
    "update_reminder_modal": "Update Reminder",
    "create_reminder_modal": "Create Reminder",
    "send_a": "Send a",
    "subject": "Subject",
    "reminder_text": "reminder",
    "days": "days",
    "time_preposition": "Time Preposition",
    "to": "to",
    "remove_reminder": "Remove reminder",
    "remove_confirm_title": "Are you sure you want to remove this reminder?",
    "remove_confirm_content": "Click confirm to remove reminder.",
    "update_reminder_aria": "update reminder"
  },
  "review_contacts_table": {
    "clear_selection": "Clear selection",
    "alert_message": "Review and manage your incoming contacts here. By selecting the checkbox next to a contact, you can choose to release them to the CRM, set them as private, or archive their details.",
    "contacts_selected": "{{count}} contacts selected",
    "contact_column": "Contact",
    "company_column": "Company",
    "location_column": "Location",
    "tags_column": "Tags",
    "last_interaction_column": "Last Interaction"
  },
  "stay_in_touch": {
    "button": "Stay In Touch",
    "modal_title": "Stay in Touch",
    "set_frequency": "Set Frequency",
    "stay_in_touch_aria_label": "Stay In Touch",
    "select_frequency": "Select frequency",
    "reminder_active_message": "Stay in Touch reminder is active, and contacts have been added to My Contacts.",
    "no_reminders_set": "You have not set any Stay in Touch Reminders",
    "due_date": "Due Date",
    "contact": "Contact",
    "firm": "Firm",
    "last_interaction": "Last Interaction"
  },
  "tags": {
    "delete_tag_confirm_title": "Are you sure you want to delete this tag?",
    "remove_tag": "remove tag",
    "tags_label": "Tags",
    "type_to_search": "Type to search tags",
    "tags_placeholder": "Tags",
    "delete_tags_confirm_title": "Are you sure you want to delete those tags?",
    "delete_tags": "Delete Tags",
    "bulk_remove_tag": "bulk remove tag",
    "name_required": "Please enter a name",
    "tag_update_notice": "It might take up to 30 minutes to update the tag on all contacts and companies.",
    "tag_created": "Tag created.",
    "tag_name_label": "Tag Name *",
    "name_tag_placeholder": "Name the tag",
    "tags_removal_notice": "It might take up to 30 minutes for the tags to be removed from all the companies and contacts.",
    "tag": "Tag",
    "used": "Used",
    "created_at": "Created at",
    "actions": "Actions",
    "tag_removal_notice": "It might take up to 30 minutes for the tag to be removed from all the companies and contacts.",
    "contacts": "Contacts",
    "companies": "Companies",
    "rename_tag": "rename tag",
    "order_by": "Order by"
  },
  "version_alert": {
    "new_update_available": "There's a new update available, please refresh the page"
  },
  "auth": {
    "logged_out_message": "You have been logged out, please refresh the page and log in again"
  },
  "interaction": {
    "from_label": "From: ",
    "to_label": "To: "
  },
  "mock": {
    "open_contact": "open contact",
    "open_company": "open company"
  },
  "grid": {
    "actions": {
      "more": "More",
      "manage_columns": "Manage Columns",
      "reminder": "Reminder",
      "request_contacts": "Request Contacts",
      "clean_list": "Clean List",
      "add_comment": "Add a Comment",
      "copy_list_id": "Copy List ID",
      "removed_history": "Removed History",
      "connected_to": "Connected to {{campaignManager}}",
      "sync_with": "Sync with {{campaignManager}}"
    },
    "export": {
      "confirmation_message": "Do you want to export all the columns including hidden ones?",
      "all_columns": "All columns",
      "visible_columns_only": "Visible columns only"
    },
    "emarketing": {
      "settings": "eMarketing Settings",
      "sync_to_tools": "Sync to eMarketing Tools"
    }
  },
  "selection": {
    "select_all": "select all",
    "select_item": "select {{label}}",
    "filter_select": "filter select {{label}}"
  },
  "timeline": {
    "no_data_available": "No timeline data available. Waiting for data...",
    "loading": "Loading...",
    "error_transforming_columns": "Error transforming column definitions",
    "error_transforming_data": "Error transforming timeline data",
    "error_occurred": "An error occurred"
  },
  "copy": {
    "copy_aria_label": "copy"
  },
  "rich_text_editor": {
    "image_size_limit_exceeded": "Image size exceeds the {{limit}} KB limit.",
    "default_aria_label": "Rich Text Editor",
    "unknown_employee": "UnknownEmployee"
  },
  "list_board": {
    "aria_labels": {
      "board_view": "list board view",
      "open_in_slide": "open in slide {{identifier}}"
    }
  },
  "tabs": {
    "search": {
      "placeholder": "Search Tabs",
      "aria_label": "search tabs",
      "button_aria_label": "tab search"
    },
    "actions": {
      "list_actions": "list actions",
      "more": "more",
      "clone": "Clone",
      "rename_tab": "rename tab"
    },
    "tooltips": {
      "duplicate_contact_enabled": "Duplicate Contact Enabled: Allow to add contacts multiple times"
    },
    "confirmations": {
      "remove_tab_title": "Are you sure you want to remove this tab?",
      "remove_tab_content": "Click confirm to remove this tab."
    }
  },
  "release_badge": {
    "beta": "Beta",
    "new": "New",
    "preview": "Preview",
    "cautions": "Cautions"
  },
  "export": {
    "export_selected": "Export Selected",
    "exporting_percentage": "Exporting: {{percentage}}%",
    "preparing_export": "Preparing your export...",
    "error_message": "We encountered an issue while exporting your data. Please try again.",
    "confirm_export": "Confirm Export",
    "confirm_proceed": "Are you sure to proceed?"
  },
  "support": {
    "contact_nexl_support": "Contact NEXL Support"
  },
  "kanban": {
    "no_data_available": "No data available",
    "unknown_id": "Unknown ID",
    "untitled": "Untitled",
    "id_label": "ID: ",
    "error_transforming_columns": "Error transforming column definitions",
    "error_transforming_data": "Error transforming kanban data",
    "no_items_to_display": "No items to display in Kanban view",
    "not_set": "Not Set",
    "open_in_slide": "open in slide {{email}}"
  },
  "bulk_add": {
    "adding_to_list": "Adding to list",
    "add_to_list": "Add to List"
  },
  "interactions": {
    "count": "{{count}} Interactions",
    "last_interaction": "Last Interaction"
  },
  "date_ranges": {
    "all_time": "All time",
    "this_month": "This month",
    "last_month": "Last month",
    "last_90_days": "Last 90 days",
    "year_to_date": "Year to date",
    "last_year": "Last year",
    "upcoming": "Upcoming"
  },
  "slide": {
    "content": "slide content",
    "close": "close slide"
  },
  "view_linkedin_profile": "View LinkedIn profile",
  "style_guide": {
    "palette": "Palette",
    "account_color": "Account Color",
    "accent_color": "Accent Color",
    "typography": "Typography"
  },
  "calendar": {
    "aria_labels": {
      "generic_item": "generic calendar item",
      "contact_item": "{{email}} calendar item",
      "calendar_item": "calendar item {{title}}"
    }
  },
  "errors": {
    "alt_text": {
      "something_went_wrong": "something-went-wrong",
      "error": "Error"
    },
    "messages": {
      "generic_error": "Sorry, something has gone wrong. Please contact support."
    },
    "titles": {
      "error": "Error!"
    }
  },
  "states": {
    "alt_text": {
      "empty_inbox": "empty-inbox"
    },
    "messages": {
      "nothing_to_show": "There's nothing to show here."
    }
  },
  "components": {
    "data_table": {
      "clear_selection": "Clear selection",
      "all_selected": "All {{count}} contacts selected",
      "items_selected": "{{count}} selected"
    },
    "selection": {
      "select_all": "select all",
      "select_row": "select row {{label}}"
    },
    "priority": {
      "set_priority": "Set priority"
    },
    "calendar": {
      "calendar_item": "calendar item",
      "error_transforming_columns": "Error transforming column definitions",
      "error_transforming_data": "Error transforming timeline data",
      "error_occurred": "An error occurred"
    },
    "exports": {
      "past_exports": "Past Exports",
      "past_export_count": "Past Export ({{count}})",
      "download": "Download"
    },
    "alerts": {
      "read_only": "Read-only.",
      "changes_not_saved": "Any changes made will not be saved."
    },
    "tooltips": {
      "tooltip_information": "tooltip information"
    }
  },
  "fields": {
    "labels": {
      "country": "Country",
      "street_address": "Street Address",
      "city": "City",
      "state": "State",
      "postcode": "Postcode",
      "contact_office_location": "Contact Office Location",
      "contact_office_address": "Contact Office Address"
    },
    "placeholders": {
      "select_country": "Select country",
      "select_office_location": "Select Office Location",
      "when_is_it_due": "when is it due",
      "type_or_select_user_email": "Type or select user's email"
    },
    "messages": {
      "no_company_office_locations_found": "No Company Office Locations Found",
      "remove_address": "Remove address",
      "contact_office_location_set_successfully": "Contact office location set successfully.",
      "start_typing_to_search_for_user": "start typing to search for user",
      "please_fill_in_all_fields_before_saving": "Please fill in all fields before saving"
    },
    "actions": {
      "add": "Add {{label}}",
      "remove": "Remove {{value}}",
      "set_as_primary": "Set {{value}} as primary"
    }
  },
  "location": {
    "search_placeholder": "Search office address",
    "address_label": "Address"
  },
  "currency": {
    "label": "Currency"
  }
}
